import React from "react";
import TreeItem from "@material-ui/lab/TreeItem";
import { createUseStyles } from "react-jss";

import TreeItemLabel from "./TreeItemLabel";

const useStyles = createUseStyles({
  arrow: {
    "& .MuiTreeItem-iconContainer": {
      display: "none",
    },
    "& .MuiFormControlLabel-root": {
      marginLeft: 10,
    },
  },
});

const TreeItemBottom = ({ nodes, selected, getOnChange }) => {
  const classes = useStyles();
  const { id } = nodes;

  return (
    <TreeItem
      className={classes.arrow}
      key={id}
      nodeId={id}
      label={
        <TreeItemLabel
          nodes={nodes}
          selected={selected}
          getOnChange={getOnChange}
        />
      }
    >
      {id}
    </TreeItem>
  );
};

export default TreeItemBottom;
